import { Action, IIncomingMessage, IOutgoingMessage } from "./interfaces";

class WebSocketParser {
  static parse(message: string): IIncomingMessage | null {
    try {
      const { action, type, target, payload, error, details, requestID } = JSON.parse(message);
      if (error) {
        return {
          errorType: error,
          errorDetails: details,
        };
      }
      return { action, type, target, payload, requestID };
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return null;
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static createMessage(action: Action, payload?: any): string {
    const message: IOutgoingMessage = { action, ...payload };
    return JSON.stringify(message);
  }
}

export default WebSocketParser;
